import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, scrollToId } from "../data/site";

const Brand = ({ go }) => (
  <button data-testid="nav-logo-link" onClick={() => go("home")} className="flex items-center gap-2.5" aria-label="VIC WRAP STUDIO home">
    <img src="/logo-icon.png" alt="VIC WRAP STUDIO logo" className="h-10 w-10 object-contain" />
    <span className="font-brand text-lg sm:text-xl font-light lowercase tracking-wide leading-none text-white">
      vicwrap<span className="text-[#FF6B00] font-medium">studio</span>
    </span>
  </button>
);

const DesktopLinks = ({ go }) => (
  <div className="hidden lg:flex items-center gap-6">
    {NAV_LINKS.map((l) => (
      <button key={l.id} data-testid={l.testid} onClick={() => go(l.id)} className="text-[11px] font-sub font-semibold tracking-[0.18em] text-zinc-300 hover:text-[#FF6B00] transition-colors duration-200">
        {l.label}
      </button>
    ))}
    <button data-testid="nav-cta-free-quote-button" onClick={() => go("quote")} className="btn-primary !px-5 !py-2.5 text-xs">
      FREE QUOTE
    </button>
  </div>
);

const MobileMenu = ({ go }) => (
  <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
    {NAV_LINKS.map((l) => (
      <button key={l.id} data-testid={`${l.testid}-mobile`} onClick={() => go(l.id)} className="text-left font-display text-2xl font-bold uppercase tracking-wide text-zinc-200 hover:text-[#FF6B00] transition-colors">
        {l.label}
      </button>
    ))}
    <button data-testid="nav-cta-free-quote-button-mobile" onClick={() => go("quote")} className="btn-primary mt-2">
      FREE QUOTE
    </button>
  </div>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-300 ${scrolled || open ? "bg-black/85 border-white/10 backdrop-blur-xl" : "bg-transparent border-transparent"}`}>
      <nav className="container-x h-[72px] flex items-center justify-between">
        <Brand go={go} />
        <DesktopLinks go={go} />
        <button data-testid="nav-mobile-menu-toggle" className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {open && <MobileMenu go={go} />}
    </header>
  );
}
